import { render, staticRenderFns } from "./DashboardRevenueSummary.vue?vue&type=template&id=6dee7806&scoped=true"
import script from "./DashboardRevenueSummary.vue?vue&type=script&lang=js"
export * from "./DashboardRevenueSummary.vue?vue&type=script&lang=js"
import style0 from "./DashboardRevenueSummary.vue?vue&type=style&index=0&id=6dee7806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee7806",
  null
  
)

export default component.exports